import { render, staticRenderFns } from "./PathologyViewer.vue?vue&type=template&id=598dc719&scoped=true"
import script from "./PathologyViewer.vue?vue&type=script&lang=js"
export * from "./PathologyViewer.vue?vue&type=script&lang=js"
import style0 from "./PathologyViewer.vue?vue&type=style&index=0&id=598dc719&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "598dc719",
  null
  
)

export default component.exports